import { subscribe, subscribeRejected, addAndModifyBetTickerBet, subscribeSettled } from './reducers/subscription';

// eslint-disable-next-line import/no-default-export
export default {
    BETS_SUBSCRIBE: subscribe,
    BETS_SUBSCRIBE_REJECTED: subscribeRejected,
    BETS_SUBSCRIBE_SETTLED: subscribeSettled,
    // TODO: Remove this modifier when Kafka bet model will be extended with ip field
    BETS_MODIFY_WITH_IP: addAndModifyBetTickerBet,
};
